<section class="card" (click)="onCardClick()" [style.border]="isSelected() ? '2px solid #008200' : '2px solid white'">
    <div class="checkbox-column">
        <input 
            type="checkbox" 
            [checked]="isSelected()" 
            class="checkbox"
        />
    </div>
    <div class="content-column">
        <lib-title [tag]="'h3'" [text]="title()"></lib-title>
        <p class="price">{{ price() }}</p>
        <section class="info-row" (click)="onInfoRowClick($event)">
            <img alt="info" src="./assets/lib/icons/Icon_Information.svg" alt="information" />
            <p class="description">{{ actionText() }}</p>
        </section>
    </div>
</section>
